import { __assign } from "tslib";
import React from 'react';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import EmptyBackground from './EmptyBackground';
import JournalStageBackground from './Journal';
import DefaultStageBackground from './Default';
import LiteratureStageBackground from './Literature';
import StatusStageBackground from './Status';
import CommissionStageBackground from './Commission';
var StageBackground = function (props) {
    if (props.deviation.isBlocked) {
        return React.createElement(EmptyBackground, null);
    }
    var deviationType = getDeviationType(props.deviation);
    switch (deviationType) {
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionStageBackground, __assign({}, props));
        case DeviationTypes.POLL:
            return React.createElement(EmptyBackground, null);
        case DeviationTypes.STATUS:
            return React.createElement(StatusStageBackground, __assign({}, props));
        case DeviationTypes.LITERATURE:
            return React.createElement(LiteratureStageBackground, __assign({}, props));
        case DeviationTypes.TIER:
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalStageBackground, __assign({}, props));
        default:
            return React.createElement(DefaultStageBackground, __assign({}, props));
    }
};
StageBackground.displayName = 'StageBackground';
export default StageBackground;
//# sourceMappingURL=StageBackground.js.map